import Crud from '../views/User/Crud'
import Entity from '../views/User/Add'

let routes = {
    path: '/users',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/users/add',
            name: 'NewUser',
            component: Entity,
            meta: {
                pageTitle: 'user.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'user.form.newTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/users/edit/:id?',
            name: 'EditUser',
            component: Entity,
            meta: {
                pageTitle: 'user.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'user.form.editTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/users',
            name: 'list-users',
            component: Crud,
            meta: {
                pageTitle: 'user.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'user.crud.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
